export class LoginCustom {
    menuComissionState: string = 'out';
    orderComissionState: string = 'out';

    /** Desktop_View classes */
    static displaySignUpForm() {
        let login = $("#m_login");
        login.removeClass("m-login--forget-password");
        login.removeClass("m-login--signin");
        login.removeClass("m-login--update-password");

        login.addClass("m-login--signup");
        (<any>login.find(".m-login__signup")).animateClass("flipInX animated");
    }

    static displaySignInForm() {
        let login = $("#m_login");
        login.removeClass("m-login--forget-password");
        login.removeClass("m-login--signup");
        login.removeClass("m-login--update-password");
        login.removeClass("m-login--reset-password");

        try {
            $("form")
                .data("validator")
                .resetForm();
        } catch (e) { }

        login.addClass("m-login--signin");
        (<any>login.find(".m-login__signin")).animateClass("flipInX animated");
    }


    static displayForgetPasswordForm() {
        let login = $("#m_login");
        login.removeClass("m-login--signin");
        login.removeClass("m-login--signup");
        login.removeClass("m-login--update-password");
        login.removeClass("m-login--reset-password");
        login.removeClass("form-control-feedback");
        try {
            $("forgetForm")
                .data("validator")
                .resetForm();
            //  $('forgetForm').data('validator').reset();
        } catch (e) { }
        login.addClass("m-login--forget-password");
        (<any>login.find(".m-login__forget-password")).animateClass(
            "flipInX animated"
        );
    }
    static displayUpdatePasswordForm() {
        let login = $("#m_login");
        login.removeClass("m-login--signin");
        login.removeClass("m-login--signup");
        login.removeClass("m-login--forget-password");
        login.addClass("m-login--update-password");
        (<any>login.find(".m-login__update-password")).animateClass(
            "flipInX animated"
        );
    }
    static displayLoginResetPassword() {
        let login = $("#m_login");
        login.removeClass("m-login--signin");
        login.removeClass("m-login--signup");
        login.removeClass("m-login--update-password");
        login.removeClass("m-login--forget-password");
        login.addClass("m-login--reset-password");
        (<any>login.find(".m-login__reset")).animateClass("flipInX animated");
    }
    static displayPartnerMobileOnBoard() {
        let login = $("#m_register");
        login.removeClass("m-register--signup");
        login.addClass("m-register--mobile");
        (<any>login.find(".m-register_mobile")).animateClass("flipInX animated");
    }

    static displayPartnerRegister() {
        let login = $("#m_register");
        login.removeClass("m-register--otp");
        login.removeClass("m-register--mobile");
        login.removeClass("m-register--final-Step");

        login.addClass("m-register--signup");
        (<any>login.find(".m-register_mobile")).animateClass("flipInX animated");
    }
    static displayPartnerRegisterOTP() {
        let login = $("#m_register");
        login.removeClass("m-register--mobile");
        login.removeClass("m-register--signup");
        login.addClass("m-register--otp");
        try {
            $("mobileForm")
                .data("validator")
                .resetForm();
            //  $('forgetForm').data('validator').reset();
        } catch (e) { }
        (<any>login.find(".m-register_otp")).animateClass("flipInX animated");
    }
    static displayPartnerRegisterFinalStep() {
        let login = $("#m_register");
        login.removeClass("m-register--mobile");
        login.removeClass("m-register--signup");
        login.removeClass("m-register--otp");
        login.addClass("m-register--final-Step");
        try {
            $("finalStepForm")
                .data("validator")
                .resetForm();
            //  $('forgetForm').data('validator').reset();
        } catch (e) { }
        (<any>login.find(".m-register_final_step_registration")).animateClass("flipInX animated");
    }

    /** Mobile_View classes starts here*/
    static displayMobileViewHome() {
        let login = $("#mobile-view");
        login.removeClass("mobile--login");
        login.removeClass("mobile--signup");
        login.addClass("mobile--home");
    }
    /** Mobile_View classes ends here*/

    /** Mobile_View handle starts here*/
    static handleMobileViewHome() {
        let login = $("#mobile-view");
        login.removeClass("mobile--login");
        login.removeClass("mobile--signup");
        login.addClass("mobile--home");
    }
    /** Mobile_View handle ends here*/


    /** Desktop_View handle starts here*/

    static handleFormSwitch() {
        $("#m_login_forget_password").click(e => {
            e.preventDefault();
            LoginCustom.displayForgetPasswordForm();
            // LoginCustom.displayLoginResetPassword();
        });
        $("#m_login_forget_password_cancel").click(e => {
            e.preventDefault();
            LoginCustom.displaySignInForm();
            let form = $(e.target).closest("form");
            form.validate().resetForm();
        });
        $("#m_login_update_password_cancel").click(e => {
            e.preventDefault();
            LoginCustom.displaySignInForm();
        });
        $("#m_login_signup").click(e => {
            e.preventDefault();
            LoginCustom.displaySignUpForm();
        });
        $("#m_login_signup_cancel").click(e => {
            e.preventDefault();
            LoginCustom.displaySignInForm();
        });
        $("#m_login_signup_cancel").click(e => {
            e.preventDefault();
            LoginCustom.displaySignInForm();
        });
        $("#m_register_btnregister").click(e => {
            e.preventDefault();
            LoginCustom.displayPartnerMobileOnBoard();

        });
        $("#m_register_final_step_cancel").click(e => {
            e.preventDefault();
            LoginCustom.displayPartnerRegister();
            let form = $(e.target).closest("form");
            form.validate().resetForm();
        });

        $("#m_register_otp_cancel").click(e => {
            e.preventDefault();
            LoginCustom.displayPartnerRegister();
            let form = $(e.target).closest("form");
            form.validate().resetForm();
        });
        // $("#m_register_otp_proceed").click(e => {
        //     e.preventDefault();
        //     LoginCustom.displayPartnerRegisterFinalStep();

        // });

    }
    static handleSignInFormSubmit() {

        $("#m_login_signin_submit").click(e => {
            let form = $(e.target).closest("form");

            form.validate({

                rules: {
                    email: {
                        required: true,
                        email: true
                    },
                    password: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }
    static handleSignUpFormSubmit() {
        $("#m_login_signup_submit").click(e => {
            let btn = $(e.target);
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    fullname: {
                        required: true
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    password: {
                        required: true
                    },
                    rpassword: {
                        required: true
                    },
                    agree: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }

    static handleForgetPasswordFormSubmit() {
        $("#m_login_forget_password_submit").click(e => {
            let btn = $(e.target);
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    email: {
                        required: true,
                        email: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }

    static handleResetPasswordFormSubmit() {
        $("#m_login_reset_password_submit").click(e => {
            let btn = $(e.target);
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    newPassword: {
                        required: true
                    },
                    confirmPassword: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }

    static handleUpdatePasswordFormSubmit() {
        $("#m_login_update_password_submit").click(e => {
            let btn = $(e.target);
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    verificationValue: {
                        required: true,
                        number: true
                    },
                    newPassword: {
                        required: true
                    },
                    confirmPassword: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }

    static handleMobileFormSubmit() {
        $("#m_register_mobile_proceed").click(e => {
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    mobile: {
                        required: true
                    },
                    pan: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }
    static handleOTPFormSubmit() {
        $("#m_register_otp_proceed").click(e => {
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    otp: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }
    static handleRegFinalStepFormSubmit() {
        $("#m-register_final_step_proceed").click(e => {
            let form = $(e.target).closest("form");
            form.validate({
                rules: {
                    firstName: {
                        required: true
                    },
                    lastName: {
                        required: true
                    },
                    partner: {
                        required: true
                    },
                    email: {
                        required: true,
                        email: true
                    }


                }
            });
            if (!form.valid()) {
                e.preventDefault();
                return;
            }
        });
    }
    /** Desktop_View handle ends here*/

    static init() {
        LoginCustom.handleFormSwitch();
        LoginCustom.handleSignInFormSubmit();
        LoginCustom.handleSignUpFormSubmit();
        LoginCustom.handleForgetPasswordFormSubmit();
        LoginCustom.handleUpdatePasswordFormSubmit();
        LoginCustom.handleResetPasswordFormSubmit();
        LoginCustom.handleMobileFormSubmit();
        LoginCustom.handleOTPFormSubmit();
        LoginCustom.handleRegFinalStepFormSubmit();


    }

    showOrderComission() {
        this.orderComissionState = this.orderComissionState === 'out' ? 'in' : 'out';
    }
    hoverShowOrderComission(dataShow) {
        this.orderComissionState = dataShow;
    }
    hoverHideOrderComission(dataHide) {
        this.orderComissionState = dataHide;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/_helpers/login-custom.ts